export const validators = {
  phone: (v: string) =>
    /^\+?\d{10,15}$/.test(v.trim())
      ? null
      : 'Please enter a valid phone number.',

  linkedin: (v: string) =>
    /^https:\/\/(www\.)?linkedin\.com\/.*$/.test(v.trim())
      ? null
      : 'Please enter a valid LinkedIn profile URL.',

  facebook: (v: string) =>
    /^https:\/\/(www\.)?facebook\.com\/.*$/.test(v.trim())
      ? null
      : 'Please enter a valid Facebook profile URL.',

  twitter: (v: string) =>
    /^https:\/\/(www\.)?twitter\.com\/.*$/.test(v.trim())
      ? null
      : 'Please enter a valid Twitter profile URL.',

  instagram: (v: string) =>
    /^https:\/\/(www\.)?instagram\.com\/.*$/.test(v.trim())
      ? null
      : 'Please enter a valid Instagram profile URL.',
};
